import React, { useState } from 'react';
import { X, Search, Type } from 'lucide-react';

const SearchModal = ({ onClose, onSearch, fetchSuggestions, t }) => {
    const [word, setWord] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        searchAndClose(word);
    };

    const searchAndClose = (searchTerm) => {
        if (searchTerm.trim().length >= 3) {
            onSearch(searchTerm);
            setWord('');
            setSuggestions([]);
        }
    };

    React.useEffect(() => {
        const timer = setTimeout(async () => {
            if (word.trim().length >= 3 && fetchSuggestions) {
                const results = await fetchSuggestions(word);
                setSuggestions(results);
            } else {
                setSuggestions([]);
            }
        }, 500);

        return () => clearTimeout(timer);
    }, [word, fetchSuggestions]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                onClick={onClose}
            ></div>

            {/* Modal Card */}
            <div className="relative bg-white border-4 border-black p-6 md:p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] w-full max-w-xl animate-fade-in-up">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-2 bg-red-500 border-2 border-black shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:translate-y-1 hover:shadow-none transition-all"
                >
                    <X size={20} className="text-white" strokeWidth={3} />
                </button>

                {/* Header */}
                <h2 className="text-3xl font-black uppercase mb-8 flex items-center gap-2">
                    <Search size={32} strokeWidth={4} className="text-[#8c52ff]" />
                    {t?.searchTitle || 'SEARCH WORD'}
                </h2>

                {/* Form */}
                <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                    <div className="relative flex-grow">
                        <input
                            autoFocus
                            type="text"
                            value={word}
                            onChange={(e) => setWord(e.target.value)}
                            placeholder={t?.searchPlaceholder || 'Type something...'}
                            className="w-full h-16 px-6 text-2xl font-bold border-4 border-black bg-white focus:outline-none focus:translate-x-[-4px] focus:translate-y-[-4px] focus:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] transition-all placeholder:text-gray-400 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
                        />
                        <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <Type size={24} strokeWidth={3} className="text-gray-400" />
                        </div>

                        {/* Suggestions Dropdown */}
                        {suggestions.length > 0 && (
                            <div className="absolute z-10 w-full bg-white border-4 border-black border-t-0 max-h-60 overflow-y-auto shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                                {suggestions.map((suggestion, index) => (
                                    <div
                                        key={index}
                                        onClick={() => searchAndClose(suggestion)}
                                        className="px-6 py-3 cursor-pointer hover:bg-gray-100 font-bold text-lg border-b-2 border-gray-100 last:border-b-0"
                                    >
                                        {suggestion}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <button
                        type="submit"
                        className="h-16 px-8 bg-[#8c52ff] text-white text-xl font-black border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] active:translate-x-[4px] active:translate-y-[4px] active:shadow-none transition-all flex items-center justify-center gap-2"
                    >
                        {t?.searchButton || 'SEARCH'} <Search size={24} strokeWidth={3} />
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SearchModal;
